module.exports = __webpack_public_path__ + "static/media/404.5830ea2b.svg";